(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let lastFocus = null;

  const overlay = () => document.querySelector('[data-kashi-overlay]');

  function goToSlide(carousel, index) {
    const slides = [...carousel.querySelectorAll('[data-kashi-slide]')];
    if (!slides.length) return;
    const count = slides.length;
    const target = ((index % count) + count) % count;
    slides.forEach((s) => {
      const active = s.getAttribute('data-kashi-slide') === String(target);
      s.classList.toggle('is-active', active);
      s.hidden = !active;
    });
    carousel.querySelectorAll('[data-kashi-carousel-dot]').forEach((d) => {
      d.classList.toggle('is-active', d.getAttribute('data-kashi-carousel-dot') === String(target));
    });
  }

  document.addEventListener('click', (e) => {
    const prev = e.target.closest('[data-kashi-carousel-prev]');
    const next = e.target.closest('[data-kashi-carousel-next]');
    const dot = e.target.closest('[data-kashi-carousel-dot]');
    if (prev || next || dot) {
      const carousel = e.target.closest('[data-kashi-carousel]');
      if (!carousel) return;
      const current = carousel.querySelector('[data-kashi-slide].is-active');
      const currentIndex = current ? parseInt(current.getAttribute('data-kashi-slide'), 10) : 0;
      if (dot) goToSlide(carousel, parseInt(dot.getAttribute('data-kashi-carousel-dot'), 10));
      else if (prev) goToSlide(carousel, currentIndex - 1);
      else goToSlide(carousel, currentIndex + 1);
      return;
    }
    const toggleBtn = e.target.closest('[data-kashi-toggle-btn]');
    if (toggleBtn) {
      const group = toggleBtn.closest('[data-kashi-toggle]');
      if (!group) return;
      const index = toggleBtn.getAttribute('data-kashi-toggle-btn');
      group.querySelectorAll('[data-kashi-toggle-btn]').forEach((b) => {
        b.classList.toggle('is-active', b === toggleBtn);
      });
      group.querySelectorAll('[data-kashi-toggle-photo]').forEach((p) => {
        const active = p.getAttribute('data-kashi-toggle-photo') === index;
        p.classList.toggle('is-active', active);
        p.hidden = !active;
      });
      return;
    }
    const tab = e.target.closest('[data-kashi-values-tab]');
    if (!tab) return;
    const group = tab.closest('[data-kashi-values]');
    if (!group) return;
    const index = tab.getAttribute('data-kashi-values-tab');
    group.querySelectorAll('[data-kashi-values-tab]').forEach((t) => {
      const active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    group.querySelectorAll('[data-kashi-values-panel]').forEach((p) => {
      p.classList.toggle('is-active', p.getAttribute('data-kashi-values-panel') === index);
      p.hidden = p.getAttribute('data-kashi-values-panel') !== index;
    });
  });

  function closeAll(keepLock) {
    document.querySelectorAll('.kashi-panel.is-open').forEach((p) => {
      p.classList.remove('is-open');
      p.setAttribute('inert', '');
    });
    document.querySelectorAll('[data-kashi-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!keepLock) {
      const o = overlay();
      if (o) o.classList.remove('is-open');
      document.body.classList.remove('kashi-locked');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }

  function openPanel(name) {
    const panel = document.getElementById('kashi-' + name + '-panel');
    if (!panel) return;
    if (!document.querySelector('.kashi-panel.is-open')) lastFocus = document.activeElement;
    closeAll(true);
    panel.classList.add('is-open');
    panel.removeAttribute('inert');
    const o = overlay();
    if (o) o.classList.add('is-open');
    document.body.classList.add('kashi-locked');
    const trigger = document.querySelector('[data-kashi-open="' + name + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    const first = panel.querySelector('a, button');
    if (first) first.focus();
  }

  async function refreshCart() {
    const res = await fetch(root + '?sections=kashi-cart-data');
    if (!res.ok) return;
    const data = await res.json();
    const doc = new DOMParser().parseFromString(data['kashi-cart-data'], 'text/html');
    const newBody = doc.querySelector('[data-kashi-cart-body-src]');
    const body = document.querySelector('[data-kashi-cart-body]');
    if (newBody && body) body.innerHTML = newBody.innerHTML;
    const newLabel = doc.querySelector('[data-kashi-cart-label]');
    const btn = document.querySelector('[data-kashi-open="cart"]');
    if (newLabel && btn) btn.textContent = newLabel.textContent;
  }

  document.addEventListener('click', async (e) => {
    const opener = e.target.closest('[data-kashi-open]');
    if (opener) {
      e.preventDefault();
      openPanel(opener.getAttribute('data-kashi-open'));
      return;
    }
    if (e.target.closest('[data-kashi-close]') || e.target === overlay()) {
      closeAll();
      return;
    }
    const remove = e.target.closest('[data-kashi-remove]');
    if (remove) {
      e.preventDefault();
      try {
        const res = await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: remove.getAttribute('data-kashi-remove'), quantity: 0 }),
        });
        if (!res.ok) throw new Error('change failed');
        await refreshCart();
      } catch (err) {
        window.location.href = remove.href;
      }
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.querySelector('.kashi-panel.is-open')) closeAll();
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches || !form.matches('#kashi-product-form')) return;
    e.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) throw new Error('add failed');
      await refreshCart();
      openPanel('cart');
    } catch (err) {
      form.submit();
    } finally {
      if (button) button.disabled = false;
    }
  });

  /* Email signup popups. Shopify's spam protection only lets normal page-level
     form submits through, so the email and the survey answers are each sent with
     a regular form post. Shopify returns the customer to this page afterwards and
     the popups carry on from there. */
  const EMAIL_KEY = 'kashiEmail';
  const survey = { email: '', colour: '', height: '', size: '', submitting: false, timer: null, lastFocus: null };
  const surveyEl = () => document.querySelector('[data-kashi-survey]');

  const store = {
    get() { try { return sessionStorage.getItem(EMAIL_KEY) || ''; } catch (err) { return ''; } },
    set(v) { try { sessionStorage.setItem(EMAIL_KEY, v); } catch (err) { /* private mode */ } },
    clear() { try { sessionStorage.removeItem(EMAIL_KEY); } catch (err) { /* private mode */ } },
  };

  function surveyStep(n) {
    const el = surveyEl();
    if (!el) return;
    el.querySelectorAll('[data-kashi-survey-step]').forEach((s) => {
      s.hidden = s.getAttribute('data-kashi-survey-step') !== String(n);
    });
    const first = el.querySelector('[data-kashi-survey-step="' + n + '"] input');
    if (first) first.focus({ preventScroll: true });
  }

  function primeCaptcha(form) {
    if (!form || form.dataset.kashiPrimed) return;
    form.dataset.kashiPrimed = '1';
    const field = form.querySelector('input[type="hidden"]');
    if (field) field.dispatchEvent(new Event('focusin', { bubbles: true }));
  }

  function openSurvey(step) {
    const el = surveyEl();
    if (!el) return;
    clearTimeout(survey.timer);
    survey.colour = '';
    survey.height = '';
    survey.size = '';
    survey.submitting = false;
    survey.lastFocus = document.activeElement;
    el.querySelectorAll('input[type="radio"]').forEach((r) => { r.checked = false; });
    el.removeAttribute('inert');
    el.classList.add('is-open');
    surveyStep(step);
    if (step === 1) primeCaptcha(document.getElementById('kashi-survey-form'));
  }

  function closeSurvey() {
    const el = surveyEl();
    if (!el || !el.classList.contains('is-open') || survey.submitting) return;
    clearTimeout(survey.timer);
    el.classList.remove('is-open');
    el.setAttribute('inert', '');
    if (survey.lastFocus && survey.lastFocus.focus) survey.lastFocus.focus();
  }

  function showThanks() {
    const input = document.querySelector('#kashi-signup-form input[type="email"]');
    if (!input) return;
    const msg = document.createElement('p');
    msg.className = 'kashi-product__signup-msg';
    msg.setAttribute('role', 'status');
    msg.textContent = "thank you, you're on the list";
    input.replaceWith(msg);
    const submit = document.querySelector('#kashi-signup-form button[type="submit"]');
    if (submit) submit.remove();
  }

  function submitToSheet(product) {
    const sf = document.getElementById('kashi-sheet-form');
    if (!sf) return;
    const set = (field, value) => {
      const input = sf.querySelector('[data-kashi-sheet-field="' + field + '"]');
      if (input) input.value = value;
    };
    set('email', survey.email);
    set('product', product);
    set('colour', survey.colour);
    set('height', survey.height);
    set('size', survey.size);
    if (sf.requestSubmit) sf.requestSubmit();
    else sf.submit();
  }

  function submitSurvey() {
    const f = document.getElementById('kashi-survey-form');
    const el = surveyEl();
    if (!f || !el) return;
    survey.submitting = true;
    const product = el.getAttribute('data-product-title') || '';
    f.querySelector('[name="contact[email]"]').value = survey.email;
    f.querySelector('[name="contact[Colour]"]').value = survey.colour;
    f.querySelector('[name="contact[Height]"]').value = survey.height;
    f.querySelector('[name="contact[Size]"]').value = survey.size;
    f.querySelector('[name="contact[body]"]').value =
      'Waitlist survey for ' + product + ' - colour: ' + survey.colour +
      ', height: ' + survey.height + ', size: ' + survey.size;
    submitToSheet(product);
    setTimeout(() => {
      if (f.requestSubmit) f.requestSubmit();
      else f.submit();
    }, 500);
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches || !form.matches('#kashi-signup-form') || !surveyEl()) return;
    const input = form.querySelector('input[type="email"]');
    if (input && input.value.trim()) store.set(input.value.trim());
  });

  document.addEventListener('change', (e) => {
    const input = e.target;
    const el = surveyEl();
    if (!el || !el.contains(input) || input.type !== 'radio' || survey.submitting) return;
    if (input.name === 'kashi-colour') {
      survey.colour = input.value;
      setTimeout(() => surveyStep(2), 400);
      return;
    }
    if (input.name === 'kashi-height') survey.height = input.value;
    if (input.name === 'kashi-size') survey.size = input.value;
    if (survey.height && survey.size) setTimeout(submitSurvey, 300);
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('[data-kashi-survey-close]')) closeSurvey();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSurvey();
  });

  if (window === window.top && surveyEl()) {
    if (document.querySelector('[data-kashi-survey-complete]')) {
      store.clear();
      showThanks();
      openSurvey(3);
      survey.timer = setTimeout(closeSurvey, 4500);
    } else if (document.querySelector('[data-kashi-survey-autostart]')) {
      survey.email = store.get();
      if (survey.email) openSurvey(1);
    }
  }

  document.querySelectorAll('[data-kashi-carousel]').forEach((carousel) => {
    let startX = 0;
    let startY = 0;
    let tracking = false;
    carousel.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });
    carousel.addEventListener('touchend', (e) => {
      if (!tracking) return;
      tracking = false;
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      const current = carousel.querySelector('[data-kashi-slide].is-active');
      const currentIndex = current ? parseInt(current.getAttribute('data-kashi-slide'), 10) : 0;
      goToSlide(carousel, dx < 0 ? currentIndex + 1 : currentIndex - 1);
    }, { passive: true });
  });
})();
